import { Avatar } from "@webmotors/eleanor-ui";
import { ContextMenu, Text, useDrawer } from "../../../elements";
import { HeartIcon, MenuIcon, MessagesIcon } from "../../../icons";
import { classNames } from "../../../support/formatters/class-formatter";
import { useNavbar } from "../hooks";

import styles from "./navbar-buttons.module.css";
import { useEffect, useState } from "react";

export function NavbarButtons() {
  const {
    baseURL,
    user,
    onLogout,
    showNotification,
    userLinks,
    favoriteVehicles,
    unreadChats,
    returnUrl,
    shouldOpenInSameWindow,
  } = useNavbar();
  const linkTarget = shouldOpenInSameWindow ? undefined : "_blank";
  const linkRel = shouldOpenInSameWindow ? undefined : "noreferrer";
  const { open } = useDrawer();
  const [dataQaDevice, setDataQaDevice] = useState('')

  const handleOpenMenu = () => open("mobile-drawer-menu");

  const handleLogout = () => {
    if (onLogout) {
      onLogout();
    }
  };

  const loggedLinks = userLinks
    .flatMap(({ links }) => links)
    .filter((link) => link.render !== "mobileOnly");

  const menuLinkClass = classNames(styles.MenuLink, styles.MobileHidden);

  const handleLoginClick = () => {
    const baseLoginUrl = `${baseURL}/login?lkid=1364`;

    const loginUrl = returnUrl
      ? returnUrl(`${baseURL}/login?lkid=1364`)
      : baseLoginUrl;

    window.open(loginUrl, "_self");
  };

  useEffect(() => {
    if (window.innerWidth < 842) {
      setDataQaDevice('-mobile')
    }
  }, [])

  return (
    <div className={styles.Menu}>
      <ContextMenu className={styles.MobileHidden}>
        <ContextMenu.Button>
          <button
            type="button"
            className={classNames(styles.MenuButton, styles.MobileHidden)}
            aria-label="User menu"
            data-qa={`btn_header_login${dataQaDevice}`}
          >
            <Avatar type="icon" />
            {user ? user.name : "Entrar"}
          </button>
        </ContextMenu.Button>
        <ContextMenu.Content role="menu" aria-label="User menu">
          {user ? (
            <>
              {loggedLinks.map((link) => (
                <ContextMenu.Item
                  key={link.label}
                  href={link.href}
                  as="a"
                  title={link.label}
                  target={linkTarget}
                >
                  {link.label}
                </ContextMenu.Item>
              ))}
              <ContextMenu.Item as="p" title="Sair" onClick={handleLogout}>
                Sair
              </ContextMenu.Item>
            </>
          ) : (
            <>
              <ContextMenu.Item onClick={handleLoginClick} title="Login">
                Login
              </ContextMenu.Item>
              <ContextMenu.Item
                href="https://www.cockpit.com.br/?lkid=1365"
                as="a"
                target={linkTarget}
                title="Sou Lojista"
              >
                Sou lojista
              </ContextMenu.Item>
            </>
          )}
        </ContextMenu.Content>
      </ContextMenu>

      <a
        className={menuLinkClass}
        href={`${baseURL}/garagem/favoritos?lkid=1366`}
        title="Favoritos"
        target={linkTarget}
        rel={linkRel}
        data-qa={`header_btn_favorite${dataQaDevice}`}
      >
        <HeartIcon
          viewBox="0 0 24 24"
          role="img"
          aria-labelledby="favorites-icon-title"
          title="Favorites"
          titleId="favorites-icon-title"
          size={24}
        />
        {favoriteVehicles > 0 && (
          <Text
            as="span"
            className={classNames(
              styles.FavoritesCounter,
              favoriteVehicles > 99 && styles.Over99
            )}
          >
            {favoriteVehicles > 99 ? "99+" : favoriteVehicles}
          </Text>
        )}
      </a>
      <a
        className={menuLinkClass}
        href={`${baseURL}/garagem/propostas?nps=true&lkid=1367`}
        title="Propostas"
        target={linkTarget}
        rel={linkRel}
        data-qa={`header_btn_messages${dataQaDevice}`}
      >
        <MessagesIcon
          role="img"
          aria-labelledby="proposals-icon-title"
          viewBox="0 -4 24 24"
          size={24}
          title="Proposals"
          titleId="proposals-icon-title"
        />
        {unreadChats > 0 && (
          <Text
            as="span"
            className={classNames(
              styles.UnreadChatsCounter,
              unreadChats > 99 && styles.Over99
            )}
          >
            {unreadChats > 99 ? "99+" : unreadChats}
          </Text>
        )}
      </a>
      <button
        type="button"
        className={classNames(styles.MenuButton, styles.MobileOnly)}
        onClick={handleOpenMenu}
      >
        <MenuIcon
          title="Menu"
          titleId="menu-icon-title"
          viewBox="0 0 24 24"
          size={24}
          role="img"
          aria-labelledby="menu-icon-title"
        />
        {showNotification && <span className={styles.NotificationIcon} />}
      </button>
    </div>
  );
}
